import React, { useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import Rating from '@mui/material/Rating';
import { Box, Button, TextField, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios';
import {
    subscribeRatingModal,
    closeRatingModal,
    getRatingModalState
} from './ratingModalStore';

/**
 * Hekim Analiz Puanlama Modalı.
 *
 * Başarılı bir analiz onay/revizyon işlemi sonrası backend `show_rating_modal=true`
 * döndürdüğünde, global axios interceptor bu modalı açar. Hekim analize 1-5 yıldız
 * verip opsiyonel yorum ekleyebilir. Soft gate: "Atla" ile kapatılabilir.
 *
 * Karar backend'de hesaplanır; frontend koşulları tekrar değerlendirmez.
 */
const RatingModal = () => {
    const [modalState, setModalState] = useState(getRatingModalState());
    const [rate, setRate] = useState(0);
    const [hover, setHover] = useState(-1);
    const [comment, setComment] = useState('');
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => subscribeRatingModal(setModalState), []);

    const reset = () => {
        setRate(0);
        setHover(-1);
        setComment('');
        setSubmitting(false);
    };

    const handleClose = () => {
        reset();
        closeRatingModal();
    };

    const handleSubmit = async () => {
        if (rate < 1 || submitting) return;
        setSubmitting(true);
        try {
            await axios.post(`/api2/v2/analysisrating/${modalState.analysisPk}/`, {
                rate,
                comment,
                reasons: modalState.reasons || []
            });
        } catch (e) {
            // puan gönderilemese bile modalı kapat; kullanıcı akışı kesilmesin
        }
        handleClose();
    };

    return (
        <Dialog
            open={modalState.open}
            onClose={handleClose}
            maxWidth="sm"
            fullWidth
            disableEscapeKeyDown={false}
        >
            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pr: 1 }}>
                <Typography variant="h4" component="span">
                    Analiz Değerlendirmesi
                </Typography>
                <IconButton onClick={handleClose} size="small">
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Typography sx={{ mb: 2 }}>
                    Analiz sürecini değerlendirmek ister misiniz? Geri bildiriminiz
                    analiz kalitesini artırmamıza yardımcı olur.
                </Typography>
                <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
                    <Rating
                        name="analysis-rating"
                        value={rate}
                        onChange={(event, newValue) => setRate(newValue)}
                        onChangeActive={(event, newHover) => setHover(newHover)}
                        size="large"
                        sx={{ fontSize: '2.75rem', color: '#FFB800' }}
                    />
                </Box>
                <TextField
                    label="Yorumunuz (opsiyonel)"
                    multiline
                    rows={3}
                    fullWidth
                    value={comment}
                    onChange={(event) => setComment(event.target.value)}
                />
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2.5 }}>
                <Button onClick={handleClose} color="inherit" disabled={submitting}>
                    Atla
                </Button>
                <Button
                    onClick={handleSubmit}
                    variant="contained"
                    disabled={rate < 1 || submitting}
                >
                    {submitting ? 'Gönderiliyor...' : 'Gönder'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default RatingModal;
